var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    fontSize: 16,
    color: "Secondary",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.07 13.03a1 1 0 0 0-1-1h-2.15a1 1 0 0 0-1 1V26.4a1 1 0 0 0 1 1h2.15a1 1 0 0 0 1-1V13.03ZM22.02 35.39c.55.52 1.2.78 1.97.78.8 0 1.45-.26 1.98-.78.54-.52.81-1.17.81-1.94 0-.8-.27-1.45-.81-1.97a2.62 2.62 0 0 0-1.98-.82c-.77 0-1.42.27-1.97.82a2.67 2.67 0 0 0-.78 1.97c0 .77.26 1.42.78 1.94Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46 24a22 22 0 1 0-44 0 22 22 0 0 0 44 0Zm-4 0a18 18 0 1 1-36 0 18 18 0 0 1 36 0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.a48a632d3f740c1d206cbe08d988d7de.svg";
export { ForwardRef as ReactComponent };